import { useEffect } from 'react';

/**
 * Confirmation en modale, à la place de window.confirm.
 *
 * La boîte native ne peut ni porter la charte, ni expliquer la conséquence
 * réelle d'une action — or c'est justement ce qu'on veut dire avant une
 * suppression : ce qui va se passer, et si c'est réversible.
 *
 * Props : titre, message, detail (optionnel), libelleConfirmer, danger, onConfirm, onClose
 */
export default function ConfirmModal({
  titre,
  message,
  detail,
  libelleConfirmer = 'Confirmer',
  danger = false,
  busy = false,
  onConfirm,
  onClose,
}) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
      if (e.key === 'Enter' && !busy) onConfirm?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose, onConfirm, busy]);

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,.5)', zIndex: 1100,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 460, background: 'white', borderRadius: 14, padding: 22 }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <h3 style={{ margin: 0, fontSize: 17, color: '#0f172a' }}>{titre}</h3>
          <button
            onClick={onClose}
            aria-label="Fermer"
            style={{ border: 'none', background: 'transparent', fontSize: 22, cursor: 'pointer', color: '#94a3b8', lineHeight: 1 }}
          >
            &times;
          </button>
        </div>

        <p style={{ margin: '10px 0 0', fontSize: 13.5, color: '#475569', lineHeight: 1.55 }}>{message}</p>
        {detail && (
          <p style={{ margin: '8px 0 0', fontSize: 12.5, color: '#64748b', lineHeight: 1.5 }}>{detail}</p>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            style={{
              padding: '8px 14px', borderRadius: 8, border: '1px solid #cbd5e1',
              background: 'white', color: '#334155', fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            style={{
              padding: '8px 16px', borderRadius: 8, border: 'none',
              background: danger ? '#dc2626' : '#4f46e5', color: '#fff',
              fontSize: 13, fontWeight: 600, cursor: busy ? 'default' : 'pointer',
              opacity: busy ? 0.7 : 1,
            }}
          >
            {busy ? 'En cours…' : libelleConfirmer}
          </button>
        </div>
      </div>
    </div>
  );
}
